<template>
  <div class="ma-4 px-4">
    <searchBar
      @add="(dialog = true), (editMode = false)"
      @updateSearch="(v) => (search = v)"
      headerText=""
      @fileUploaded="initialise"
    />

    <v-row>
      <v-col cols="12">
        <v-sheet outlined>
          <v-data-table
            :headers="headers"
            :search="search"
            :items="videoCourses"
            :custom-filter="customFilter"
            fixed-header
            class="secondary row-height-50"
          >
            <template #[`item.course_id`]="{ item }">
              {{ getCourse(item) }}
            </template>
            <template #[`item.url`]="{ value }">
              <a :href="value" target="_blank"> {{ value }}</a>
            </template>
            <template #[`item.action`]="{ item }">
              <v-icon small class="mr-2" color="accent" @click="edit(item)">
                mdi-pencil
              </v-icon>
            </template>
          </v-data-table>
        </v-sheet>
      </v-col>
    </v-row>
    <v-dialog v-model="dialog" width="800" persistent scrollable>
      <formDialog
        v-if="dialog"
        @closeDialog="dialog = false"
        @create="createCourse"
        @update="updateCourse"
        :video_course="video_course"
        :courses="courses"
        :edit="editMode"
      />
    </v-dialog>
  </div>
</template>

<script>
import formDialog from "@/components/course/videos.vue";
import searchBar from "@/components/searchBar.vue";
import { courseVideoHeaders } from "@/constants/headers";
export default {
  components: {
    formDialog,
    searchBar,
  },
  data() {
    return {
      dialog: false,
      editMode: false,
      department: {},
      deleteDialog: false,
      currentItem: {},
      video_course: {},
      courses: [],
      videoCourses: [],
      search: "",
      headers: courseVideoHeaders,
    };
  },
  watch: {},
  computed: {},
  created() {
    this.course_id = this.$route.query.id;
    this.course_name = this.$route.query.name;
    this.$store.commit("setBreadcrumbs", [
      { text: "Courses", to: { name: "Courses" } },
      {
        text: this.course_name,
        to: {
          path: "/course_sections",
          query: { id: this.course_id, name: this.course_name },
        },
      },
      { text: "Video Courses" },
    ]);
    this.initialise();
  },
  methods: {
    async initialise() {
      try {
        const [videoCourseRes, coursesRes] = await Promise.all([
          this.$axios.get("course_videos"),
          this.$axios.get("courses"),
        ]);

        const videoCourseData = videoCourseRes.data.data;
        this.courses = coursesRes.data.data;
        this.videoCourses = videoCourseData
          .filter((s) => s.course_id == this.course_id)
          .sort((a, b) => b.id - a.id);
      } catch (error) {
        const errorMessage = await this.$store.dispatch(
          "throwError",
          error.response
        );
        this.$store.commit("showSnackbar", {
          message: errorMessage,
          color: "error",
        });
      }
    },
    async createCourse(data) {
      await this.$axios
        .post("course_videos", { course_video: data })
        .then(() => {
          this.$store.commit("showSnackbar", {
            message: "Course Video created successfully",
            color: "success",
          });
          this.resetValues();
          this.initialise();
        })
        .catch(async (error) => {
          const errorMessage = await this.$store.dispatch(
            "throwError",
            error.response
          );
          this.$store.commit("showSnackbar", {
            message: errorMessage,
            color: "error",
          });
        });
    },
    async updateCourse(data) {
      await this.$axios
        .put("course_videos/" + data.id, { course_video: data })
        .then(() => {
          this.$store.commit("showSnackbar", {
            message: "Course Video updated successfully",
            color: "success",
          });
          this.resetValues();
          this.initialise();
        })
        .catch(async (error) => {
          const errorMessage = await this.$store.dispatch(
            "throwError",
            error.response
          );
          this.$store.commit("showSnackbar", {
            message: errorMessage,
            color: "error",
          });
        });
    },

    edit(item) {
      this.video_course = { ...item };
      this.editMode = true;
      this.dialog = true;
    },
    resetValues() {
      this.editMode = false;
      this.dialog = false;
      this.deleteDialog = false;
      this.video_course = {};
    },
    getCourse(item) {
      return this.courses.find((x) => x.id == item.course_id)?.name;
    },
    customFilter(value, search, item) {
      if (!search) return true;
      const course = this.getCourse(item);
      return (
        JSON.stringify(item).toLowerCase().includes(search.toLowerCase()) ||
        course.toLowerCase().includes(search.toLowerCase())
      );
    },
  },
};
</script>

<style></style>
